import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]
  static values = { max: { type: Number, default: 150 } }

  connect() { this.update() }

  update() {
    const text = this.inputTarget.value.trim()
    const words = text.length === 0 ? 0 : text.split(/\s+/).length
    const remaining = this.maxValue - words

    this.countTarget.textContent = `${words}/${this.maxValue} words`
    this.countTarget.classList.remove("text-muted", "text-warning", "text-danger")

    if (remaining < 0) {
      this.countTarget.classList.add("text-danger")
    } else if (remaining <= 20) {
      this.countTarget.classList.add("text-warning")
    } else {
      this.countTarget.classList.add("text-muted")
    }
  }
}
